var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_933",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_0_933)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_933)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -3.125,
    width: 21.875,
    height: 25,
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_0_933",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_933",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_933",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAADaUlEQVR4Ae3dMYqUWxiE4TIUxUzMjATFXBOXIOJKBDM3YaSRe9NAA5lVqDQoDNLB//XrB9bwXjA7dbrOU41GcyfxPwUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQWwwIMkb5O8uvAmmr/wY439C4HbSb4k+fn7z4cktwYX0/zgozy6IfD82vh/vgQfB18Cmt94k3cOBO4k+Qq+BDQ/qOrRLYHHSb6f+RJ8Ovg3Ac1vvct7BwJ0RJofVPXolgAdkea33uW9AwE6Is0Pqnp0S4COSPNb7/LegQAdkeYHVT26JUBHpPmtd3nvQICOSPODqh7dEqAj0vzWu7x3IEBHpPlBVY9uCdARaX7rXd47EKAj0vygqke3BOiINL/1Lu8dCNARaX5Q1aNbAnREmt96l/cOBOiIND+o6tEtAToizW+9y3sHAnREmh9U9eiWAB2R5rfe5b0DAToizQ+qenRLgI5I81vv8t6BAB2R5gdVPbolQEek+a13ee9AgI5I84OqHt0SoCPS/Na7vHcgQEek+UFVj24J0BFpfutd3jsQeJrk6syPob0/eAfNH/wYj20KnBvxR5JHBz+U5g9+jMe2BOiANL/1Lu89IHBuvNP/l8B/Ag7gtR95An8Mnebb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar70/FovhqvvTwdj+bb/ar7303y7cyPax/9/cGnPPnVs9V4N6H8CzD+6f3PYP4mGFa/4d5fP7B5ya+P/3ztSzDNV+PdlPIPk7xL8vrCB91P8ibJywvzxhRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQUUUEABBRRQQAEFFFBAAQUUUEABBRT4HwR+ASYDxpb6GVjHAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextHistory);
export default __webpack_public_path__ + "static/media/next_history.850d41c5009272cfe41f58822cc7d7d0.svg";
export { ForwardRef as ReactComponent };